/**
 * The vocabulary and shapes the contact drawer's merged feed is built from.
 *
 * The kind constants live here with the union they define, rather than being
 * imported back from the module that groups them.
 *
 * Here rather than beside the grouping logic so a consumer can name a record
 * without importing the module that groups them.
 */

export const PMS_APPOINTMENTS = `appointments`
export const PMS_TRANSACTIONS = `transactions`
export const PMS_TREATMENT_PLANS = `treatment-plans`
export const PMS_COMM_LOG = `comm-log`
/** Trackable's own activity records, which share the Timeline with PMS ones. */
export const RECORD_ACTIVITIES = `activities`

export type PmsRecordKind =
  | typeof PMS_APPOINTMENTS
  | typeof PMS_TRANSACTIONS
  | typeof PMS_TREATMENT_PLANS
  | typeof PMS_COMM_LOG
  | typeof RECORD_ACTIVITIES

/** Every kind there is, for validating a selection that came from outside the app. */
export const PMS_RECORD_KINDS: PmsRecordKind[] = [
  PMS_APPOINTMENTS,
  PMS_TRANSACTIONS,
  PMS_TREATMENT_PLANS,
  PMS_COMM_LOG,
  RECORD_ACTIVITIES,
]

/** What every feed record carries regardless of what it holds. */
export type PmsRecordLike = { kind: PmsRecordKind; date?: string | null }

export type PmsRecord<T = unknown> = {
  kind: PmsRecordKind
  /** Sort key. Records with no usable date sort last rather than disappearing. */
  date?: string | null
  item: T
}

export type PmsRecordGroup<R extends PmsRecordLike = PmsRecord> = {
  label: string
  records: R[]
}

/**
 * A line in the feed: either one record, or several folded into a single card.
 *
 * A `run` is that fold. It is what three payments posted on one day, or ninety
 * automated reminders, become once the feed stops giving each of them its own
 * card. The records are all still there; only the chrome around them collapses.
 */
export type PmsRow<R extends PmsRecordLike = PmsRecord> = { kind: `record`; record: R } | { kind: `run`; records: R[] }
